import Firebase from 'firebase';
import config from './config.json';

let firebaseInit = null;

export default function () {
  if (Firebase.apps.length === 0) {
    // Firebase.initializeApp(config);
    firebaseInit = Firebase.initializeApp(config);
  }
  return firebaseInit;
}



// WEBPACK FOOTER //
// ./src/firebase/index.js